import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CarouselApi } from "@/components/ui/carousel";
import React from "react";

const DotsNavigation = ({
  currentIndex,
  carouselApi,
  index,
}: {
  currentIndex: number;
  carouselApi: CarouselApi;
  index: number;
}) => {
  return (
    <div className="flex gap-2">
      <Button
        key={index}
        variant="ghost"
        size="icon"
        className={cn(
          "h-2 w-2 rounded-full border border-white bg-gray-300 md:h-2.5 md:w-2.5",
          index === currentIndex ? "bg-white" : "bg-transparent"
        )}
        onClick={(e) => {
          e.preventDefault();
          carouselApi?.scrollTo(index);
        }}
      />
    </div>
  );
};

export default DotsNavigation;
